import React, { ReactNode } from 'react';
import { Box, Button, Typography, IconButton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { headerProps, headerTypographyProps } from '../../styles/sxStyling';
import { useFilterDisplay } from '../../contexts/FilterDisplayProvider';

interface IAddButtonProps {
  onAdd?: () => void;
}

export function AddButton({ onAdd }: IAddButtonProps) {
  const navigate = useNavigate();
  const handleAdd = onAdd ?? (() => navigate('new'));

  return (
    <Button onClick={handleAdd} color="primary" variant="contained">
      Add
    </Button>
  );
}

interface IListHeaderProps {
  title: string;
  rightActions?: ReactNode;
}

export default function ListHeader({ title, rightActions = <AddButton /> }: IListHeaderProps) {
  const { showFilters, toggleFilters } = useFilterDisplay();

  return (
    <Box sx={headerProps}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography {...headerTypographyProps}>{title}</Typography>

        <IconButton
          size="small"
          onClick={toggleFilters}
          color={showFilters ? 'primary' : 'default'}
          aria-label="Toggle filters panel"
          aria-pressed={!!showFilters}
          disabled={showFilters === undefined}
        >
          <FilterAltIcon />
        </IconButton>
      </Box>

      {rightActions}
    </Box>
  );
}
